import React, { useState } from 'react';
import { fundamentalBeliefs } from '../data/beliefs';

export function BeliefsPage() {
    const [expandedBeliefs, setExpandedBeliefs] = useState({});

    const toggleBelief = (beliefId) => {
        setExpandedBeliefs(prev => ({
            ...prev,
            [beliefId]: !prev[beliefId]
        }));
    };

    return (
        <div className="max-w-6xl mx-auto">
            <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">28 Fundamental Beliefs</h2>
                <p className="text-gray-600">
                    The fundamental beliefs of the Seventh-day Adventist Church.
                    These beliefs constitute the church's understanding and expression of the teaching of Scripture.
                </p>
            </div>

            <div className="mb-6 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-500">
                <p className="text-blue-700 italic">
                    "Seventh-day Adventists accept the Bible as their only creed and hold certain fundamental beliefs
                    to be the teaching of the Holy Scriptures. These beliefs constitute the church's understanding
                    and expression of the teaching of Scripture."
                </p>
            </div>

            <div className="space-y-3">
                {fundamentalBeliefs.map((belief) => (
                    <div key={belief.id} className="bg-white rounded-lg shadow-sm overflow-hidden border">
                        <button
                            onClick={() => toggleBelief(belief.id)}
                            className="w-full p-4 text-left hover:bg-gray-50 transition duration-200"
                        >
                            <div className="flex justify-between items-start">
                                <div className="flex-1">
                                    <div className="flex items-center space-x-3">
                                        <span className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-sm font-semibold">
                                            {belief.id}
                                        </span>
                                        <h3 className="text-lg font-semibold text-gray-800">{belief.title}</h3>
                                    </div>
                                    <p className="text-gray-600 mt-2 ml-11">{belief.summary}</p>
                                </div>
                                <span className={`flex-shrink-0 ml-4 transform transition-transform duration-200 ${expandedBeliefs[belief.id] ? 'rotate-180' : ''}`}>
                                    ▼
                                </span>
                            </div>
                        </button>

                        {expandedBeliefs[belief.id] && (
                            <div className="px-4 pb-4 ml-11 border-t border-gray-100 pt-4">
                                <div className="prose max-w-none">
                                    <p className="text-gray-700 leading-relaxed">{belief.content}</p>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">Study Guide</h3>
                <div className="grid md:grid-cols-2 gap-6">
                    <div>
                        <h4 className="font-medium text-gray-700 mb-2">For Personal Study:</h4>
                        <ul className="text-gray-600 space-y-1 text-sm">
                            <li>• Read each belief carefully with Bible in hand</li>
                            <li>• Look up the supporting Bible texts</li>
                            <li>• Reflect on how each belief impacts your life</li>
                            <li>• Memorize key verses for each belief</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-medium text-gray-700 mb-2">For Ministry:</h4>
                        <ul className="text-gray-600 space-y-1 text-sm">
                            <li>• Use these beliefs to explain Adventist doctrine</li>
                            <li>• Share them with interested individuals</li>
                            <li>• Teach them to Pathfinders and youth</li>
                            <li>• Incorporate them into sermons and studies</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
